import { nextTick, isRef } from 'vue';
import { createI18n } from 'vue-i18n';
import type { I18n, Locale, VueI18n, Composer, I18nMode } from 'vue-i18n';

function isComposer(instance: VueI18n | Composer, mode: I18nMode): instance is Composer {
  return mode === 'composition' && isRef(instance.locale);
}

export function getLocale(i18n: I18n): string {
  if (isComposer(i18n.global, i18n.mode)) {
    return i18n.global.locale.value;
  } else {
    return i18n.global.locale;
  }
}

export function setLocale(i18n: I18n, locale: Locale): void {
  if (isComposer(i18n.global, i18n.mode)) {
    i18n.global.locale.value = locale;
  } else {
    i18n.global.locale = locale;
  }
}

export function setupI18n(): I18n {
  const options = {
    legacy: false, // you must set `false`, to use Composition API
    // Refer a global scope Composer instance of i18n
    globalInjection: true,
    locale: 'en-US',
    fallbackLocale: 'en-US',
    messages: {},
  };
  const i18n = createI18n(options);
  setLocale(i18n, options.locale);
  return i18n;
}

const getResourceMessages = (r: any) => r.default || r;

export async function loadLocaleMessages(i18n: I18n, locale: Locale) {
  const messages = await import(`./locales/${locale}.json`).then(getResourceMessages);
  i18n.global.setLocaleMessage(locale, messages);

  setLocale(i18n, locale);
  return nextTick();
}

export default setupI18n();
